import { render, staticRenderFns } from "./ComboboxField.vue?vue&type=template&id=252ba4d4&scoped=true&"
import script from "./ComboboxField.vue?vue&type=script&lang=ts&"
export * from "./ComboboxField.vue?vue&type=script&lang=ts&"
import style0 from "./ComboboxField.vue?vue&type=style&index=0&id=252ba4d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252ba4d4",
  null
  
)

export default component.exports